import { createContext, useContext } from 'react';

export const ProjectLinkProjectsContext = createContext();

export const useProjectLinkProjectsContext = () =>
  useContext(ProjectLinkProjectsContext);

export default ProjectLinkProjectsContext;
